import $ from 'jquery';
import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import moment from 'moment';
import session from '@/models/v5/session';
import SignupAccount from '@/models/v5/signup_account';
import template from '@/../templates/login-signin.hbs';
import CapsLockView from '@/views/caps_lock_warning_for_password_field';

    var globalCh = Radio.channel('global');

  function error_signin_429(response) {
    // Retry-after header shows number of seconds before the next
    // password / authentication attempt can be made.
    // To use moment we have to changet to change to milliseconds.
    var timeout = moment.duration(
                    parseInt(response.getResponseHeader('Retry-After'), 10)*1000),
        message_tmpl = Handlebars.compile(
                        "Too many login attempts. Please try to sign in "
                      + "again in {{duration}} {{units}}"),
        data = {
          duration: timeout.seconds(),
          units: 'seconds'
        };
    if (data.duration > 60) {
      data.duration = timeout.minutes();
      data.units = 'minutes';
    }
    Radio.request(
        'alerts',
        'showAlert', {
            message: message_tmpl(data),
            messageType: 'danger'
        }
    );
  }

  export default Marionette.View.extend({
    template : Handlebars.compile(template),
    regions: {
        passwordCapsLock : '@ui.password_caps_lock',
    },
    ui: {
        loginEmail: '#login-email',
        loginPassword: '#login-password',
        signupEmail: '#signup-email',
        signupButton: '#signup-button',
        cookies_ok: '.cookies-ok',
        cookie_bar: '.cookie-bar',
        password_caps_lock: '.password-caps-lock'
        // caps_lock_warning: 'caps-lock-warning',
    },
    events: {
        'submit #login_form': 'loginButtonPress',
        'submit #signup_form': 'signupButtonPress',
        'click #login_form a.forgot_password' : 'forgotPassword',
        'click @ui.cookies_ok' : 'accept_cookies',
        // 'keypress @ui.loginPassword' : 'show_caps_lock_sign',
        
    },
    initialize: function(options) {
        this.next = options.next;
        _.bindAll(this, 'handle_signup_success', 'handle_signup_error');
    },
    onRender: function () {
        this.show_caps_lock();
    },
    templateContext: function() {
        var app_features = globalCh.request('app_options', 'features');
        var customCopy = globalCh.request('app_options', 'customCopy');
        var data = {};

        if (app_features && app_features.environment_name) {
            data.env_name = app_features.environment_name;
        }
        data.powered_by = app_features && app_features.powered_by;
        // This is intentionally structured to show signup by default if not overriden
        if (app_features && app_features.signup === false) {
            data.hideSignup = true; 
        }
        if (app_features && app_features.show_cookie_disclaimer) {
            data.show_cookie_disclaimer = true;
        }
        if (app_features && app_features.show_tos_and_privacy) {
            data.show_tos_and_privacy = true;
        }
        if ( customCopy && customCopy.terms ) {
            data.terms = customCopy.terms;
        }
        return data;
    },
    onAttach: function() {
        // Focus username/email signin field
        this.ui.loginEmail.focus();
    },
    // show_caps_lock_sign: function(e) {
    //     var s = String.fromCharCode( e.which );
    //     console.log('s is', s);
    //     this.ui.caps_lock_warning.hide();
    //     $(".caps-lock-warning").hide();
    //     if ( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {
    //         console.log('T is');
    //         return $(".caps-lock-warning").show();
    //     } else {
    //         console.log('F is');
    //         return $(".caps-lock-warning").hide();
    //     }         
    // },

    showInputError: function(field, error) {
        field.siblings('.help-block').text(error);
        field.parent().addClass('has-error');
    },
    hideInputError: function(field) {
        // Hack to allow passing an event argument
        if (field.target) field = $(field.target);
        field.siblings('.help-block').text('');
        field.parent().removeClass('has-error');
    },
    forgotPassword: function(e){
        globalCh.request('forgot_password');
    },
    /**
     * Run after getting a successful response to signup_account.signup()
     */
    handle_signup_success: function() {
        Radio.request('alerts', 'showAlert', {
            header: 'Success',
            message: 'Please check your email for instructions.',
            messageType: 'success'
        });
        this.ui.signupEmail.val('');
        this.ui.signupButton.prop('disabled', false);
    },
    /** 
     * Run after getting an error repsonse to signup.account.signup()
     */
    handle_signup_error: function (resp) {
        var field_errors = [];
        var other_errors = [];
        if (!(resp && resp.responseJSON && resp.responseJSON.errors)) return;
        resp.responseJSON.errors.forEach(function(e) {
            if (e.source.pointer.indexOf('/data/attributes') == 0) {
                field_errors.push(e.detail);
            } else {
                other_errors.push(e.detail);
            }
        });

        if (field_errors.length) {
            this.showInputError(this.ui.signupEmail, field_errors.join('; '));
        } 
        if (other_errors.length) {
            Radio.request('alerts', 'showAlert', {
                header: 'Signup Error',
                message: other_errors.join('; '),
                messageType: 'danger'
            });
        }
        this.ui.signupButton.prop('disabled', false);
    }, 
    signupButtonPress: function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.ui.signupButton.prop('disabled', true);
        this.hideInputError(this.ui.signupEmail);

        var signup_account = new SignupAccount({
            email: this.ui.signupEmail.val()
        });

        signup_account.signup()
            .done(this.handle_signup_success)
            .fail(this.handle_signup_error)
        ;
    },
    loginButtonPress: function(e) {
        e.preventDefault();
        e.stopPropagation();

        var self = this;

        var id = this.ui.loginEmail.val();
        var password = this.getChildView('passwordCapsLock').ui.inputField.val();

        function go_to_next_page() {
            window.location = self.next;
        }
        function on_login_error(response) {
            // Handle too-frequent login attempts separately
            // from generic error handler.
            if (response.status === 429) {
                return error_signin_429(response);
            }

            // MFA response
            if (response.status === 403) {
                var login_token = response.responseJSON.errors[0].meta.login_token;
                return globalCh.request('show_mfa_login', login_token, id);
            }

            var message;
            if (response.status === 502){
                message = 'We\'re sorry, something has gone wrong, please try again';
                Radio.request(
                    'alerts',
                    'showAlert', {
                        header: 'Error',
                        message: message,
                        messageType: 'danger'
                    }
                );
                return;
            }
            var resp = response.responseJSON;
            var errMessage = 'Error, please try again.';
            if ( resp && resp.errors ) {
                errMessage = resp.errors[0].detail;
            }
            Radio.request(
                'alerts',
                'showAlert', {
                    header: 'Error',
                    message: errMessage,
                    messageType: 'danger'
                }
            );
        }
        session.login(id, password)
            .done(session.save)
            .done(go_to_next_page)
            .fail(on_login_error)
        ;
        return false;
    },
    accept_cookies: function(e){
         this.ui.cookie_bar.hide();
    },
    show_caps_lock: function() {
        this.showChildView('passwordCapsLock', new CapsLockView());
    }
  });


